"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _text_input = require("../../text_input");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var EmailInput = function EmailInput(_ref) {
  var register = _ref.register,
    errors = _ref.errors,
    disabled = _ref.disabled;
  var emailRegex = /^\w+([\.-]?\w+)([\.]?\w+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,4})$/;
  var error = false;
  var helperText = '';
  if (errors.email) {
    error = true;
    helperText = errors.email.message;
  }
  var validateEmail = function validateEmail(inputValue) {
    return emailRegex.test(inputValue) || 'Please enter a valid email address.';
  };
  return /*#__PURE__*/_react["default"].createElement(_text_input.TextInput, {
    disabled: disabled,
    cypressClass: "email-input",
    helperText: helperText,
    error: error,
    type: "email",
    label: "Email",
    name: "email",
    register: register({
      required: 'Email is required',
      validate: function validate(value) {
        return validateEmail(value);
      }
    })
  });
};
EmailInput.propTypes = {
  /**
   * Object containing the errors from this input field.
   */
  errors: _propTypes["default"].object,
  /**
   * A function that gets passed for the useForm hook from react-hook-form to register an input
   *
   */
  register: _propTypes["default"].func.isRequired,
  /**
   * If true, the input element will be disabled.
   */
  disabled: _propTypes["default"].bool
};
EmailInput.defaultProps = {
  errors: {},
  register: function register() {},
  disabled: false
};
var _default = exports["default"] = EmailInput;